import React from 'react';
import { EcoAssociation10Class2026 } from '../views';

const AccountGeneralPage = () => {
  return <EcoAssociation10Class2026/>;
};

export default AccountGeneralPage;